app.controller("errorDashboardController", [
	"$scope",
	"ExceptionAPI",
    "NgTableParams",
    "$modal",
    "Base64",
	"$window",
	"AdminService",
	"PatientAPI",
	function ($scope, ExceptionAPI,NgTableParams,$modal,Base64,$window,AdminService,PatientAPI) {
		this.$onInit = function () {
			$scope.AdminService = AdminService;
            $scope.ExceptionAPI = ExceptionAPI;
			$scope.practiceOptions = [];
			$scope.userOptions = [];
			$scope.fetchPractices();
			$scope.form = {searchBy: true};
		}

		const formatDate = (input) => {
			const array = input.split('/');
			return `${array[2]}-${array[1]}-${array[0]}T00:00:00`;
		}

        const fetchErrorLogs = () => {
			$scope.ExceptionAPI.isProcessing = true;
			const range = $scope.form.range.split('-');
			const option = {};
			$scope.logsResult = [];
			if($scope.form.searchBy){
				//practice
				option.practiceId = $scope.form.practice.id;
			}else{
				option.userId = $scope.form.user.id;
			}
			$scope.ExceptionAPI.fetchException(formatDate(range[0].trim()), formatDate(range[1].trim()), option)
				.then(
					function (response) {
						$scope.logsResult = response.data.map(t=>{
							const user = $scope.userOptions.find(m=>m.id === t.user_id);
							const practice = $scope.practiceOptions.find(m=>m.id === t.practice_id);
							// Errors raised before sign-in, or by users/practices no longer listed, have no match.
							return {...t,user_name: user ? user.firstName + ' '+ user.lastName : '', practice_name: practice ? practice.name : ''};
						})
						$scope.tableParams = new NgTableParams(
							{
								count: 10,
							},
							{
								counts: [],
								dataset: $scope.logsResult,
							}
						);
					},
					function (error) {}
				)
				.finally(() => {
					$scope.ExceptionAPI.isProcessing = false;
				});
		};

        $scope.openErrorDetail = (ex) => {
            $scope.errorObj = ex;
            // exception_audit_id
            // if(ex.image){
            //     $scope.errorObj.imageSrc = Base64.decode(ex.image);
            // }

			$scope.ExceptionAPI.getExceptionDetail(ex.exception_audit_id, ex.date_created).then(
				function (resp) {
					if (resp.data?.image) {
						$scope.errorObj.imageSrc = Base64.decode(resp.data?.image);
					}
				},
				function () {}
			);

			if (ex.patient_id && ex.practice_id) {
				PatientAPI.getPatient(ex.patient_id, ex.practice_id).then(
					function (resp) {
						$scope.errorObj.patient = resp.data;
					},
					function (error) {}
				);
			}

			$scope.detailsModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.error-details.tpl.html",
				show: true,
				title: "Error details",
				backdrop: "static",
				keyboard: false,
			});
		};

		$scope.goBack = () => {
			$window.history.back();
		}

		$scope.onSubmit = () => {
			fetchErrorLogs();
		};

		$scope.fetchPractices = function () {
			$scope.AdminService.isProcessing = true;
            $scope.AdminService.getAvailablePractices().then(function (resp) {
				$scope.practiceOptions = angular.copy(resp.data);
				$scope.fetchUser();
            }, function (error) {

            }).then(function () {
                $scope.AdminService.isProcessing = false;
            })
        };

		$scope.fetchUser = function () {
			$scope.AdminService.isProcessing = true;
			$scope.AdminService.getUsers()
				.then(
					function (resp) {
						$scope.userOptions = angular
							.copy(resp.data)
							.map((t) => ({...t, display: t.firstName + " " + t.lastName + " (" + t.userName + ")" }));
					},
					function (error) {}
				)
				.then(function () {
					$scope.AdminService.isProcessing = false;
				});
		};

		$scope.filterByItem = function (typedValue) {
			return $scope.userOptions.filter((t) => t.display.toLowerCase().indexOf(typedValue.toLowerCase()) !== -1);
		};
	},
]);